/* eslint-disable no-throw-literal */
import {EMPTY_OBJECT} from '../consts/commonConsts';

import {getLocalizationService} from './localisationService';

export type ApiError = {
  status: number;
  stack: string;
  message: string;
  url: string;
  data?: any;
  errors?: unknown[];
  error?: Record<string, unknown>; //TODO: this type should be replaced to AxiosError in #206287 backlog
};
export const createApiError = (error: Record<string, any>) => {
  const {t} = getLocalizationService();

  if (error?.response) {
    const {status, config, data} = error?.response || EMPTY_OBJECT;

    throw {
      status,
      stack: error?.stack || '',
      message: data?.description || error?.toJSON()?.message || 'http request failed',
      url: config?.url,
    };
  }

  const {data, config} = error || EMPTY_OBJECT;
  const errorData = data?.errors?.[0];
  
  throw {
    message: errorData?.errorDesc || t('something_went_wrong_try_again_later'),
    url: config?.url,
    status: errorData?.errorCode,
    stack: errorData?.stack || '',
    data: data?.data,
    errorData: data?.errors,
    error,
  };
};

export function isApiError(err: unknown): err is ApiError {
  return !!err && typeof err === 'object' &&
    'stack' in err &&
    'status' in err &&
    'message' in err;
}

export const is401Error = (e: unknown) =>
  (isApiError(e) ? e?.status === 401 : typeof e === 'string' && e.includes('401'));
